export function timeToNumberOfMins(time: string) {
  if (time) {
    return (Number(time.slice(0, 2)) * 60) + Number(time.slice(3, 5));
  }
  return 0;
}
